<div class="header__toolbar">
  <div class="container"></div>
</div>

<div class="header__main">
  <div class="container">
    <a [routerLink]="(authenticated$ | async) ? '/kpi' : '/'" class="header__logo">
      <picture>
        <source media="(min-width: 900px)" srcset="assets/images/logo-mylink.svg" type="image/svg+xml" />
        <img src="assets/images/logo-mylink.svg" alt="MyLink®" />
      </picture>
    </a>

    <div class="header__navbar">
      <ng-content></ng-content>
    </div>

    <div *ecpShowAuthed="true">
      <ecp-nav class="mobile" *ecpShowAuthed="true" [toRight]="true">
        <ecp-nav-item (click)="logout()" label="Logout"> </ecp-nav-item>
      </ecp-nav>
    </div>
  </div>
</div>
